import type { JSX } from 'react'

import { ChartColumnIcon } from '@buffer-mono/popcorn'

import { ProductPageTitle } from '~publish/components/ProductPageTitle'

export const InsightsPageTitle = ({
  showSaveView = true,
}: {
  showSaveView?: boolean
}): JSX.Element => (
  <ProductPageTitle
    icon={<ChartColumnIcon size={24} />}
    title="Insights"
    showSaveView={showSaveView}
  />
)
